var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.52539C0 8.89062 0.199219 9.38867 0.464844 9.6543L7.4707 16.6602C8.10156 17.291 9.13086 17.291 9.72852 16.6602L16.502 9.88672C17.1328 9.28906 17.1328 8.25977 16.502 7.62891L9.49609 0.623047C9.23047 0.357422 8.73242 0.125 8.36719 0.125H1.59375C0.697266 0.125 0 0.855469 0 1.71875V8.52539ZM3.71875 2.25C4.58203 2.25 5.3125 2.98047 5.3125 3.84375C5.3125 4.74023 4.58203 5.4375 3.71875 5.4375C2.82227 5.4375 2.125 4.74023 2.125 3.84375C2.125 2.98047 2.82227 2.25 3.71875 2.25Z",
    fill: "auto"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsIcon);
export default __webpack_public_path__ + "static/media/deals-icon.7107dfb6d78b40443f254e49315afcdd.svg";
export { ForwardRef as ReactComponent };